import React from 'react'
import Button from '../components/Button'
import { IconMenuDots } from '../components/icons'
import classNames from 'classnames'

export const RoomSection: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="RoomSection">
      {children}
    </div>
  )
}

export const RoomHeader: React.FC<{
  children: React.ReactNode
  onClickMenu?: () => void
  rightContent?: React.ReactNode
  borderTop?: boolean
}> = ({
  children,
  onClickMenu,
  rightContent,
  borderTop,
}) => {
  return (
    <div
      className={classNames('RoomHeader', { borderTop })}
    >
      <div className="name">
        {children}
      </div>
      {rightContent}
      {
        onClickMenu && (
          <Button
            onClick={onClickMenu}
            round
          >
            <img src={IconMenuDots} alt="menu" />
          </Button>
        )
      }
    </div>
  )
}
